import { render, staticRenderFns } from "./RestaurantDetail.vue?vue&type=template&id=6a3ea045&scoped=true"
import script from "./RestaurantDetail.vue?vue&type=script&lang=js"
export * from "./RestaurantDetail.vue?vue&type=script&lang=js"
import style0 from "./RestaurantDetail.vue?vue&type=style&index=0&id=6a3ea045&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3ea045",
  null
  
)

export default component.exports